var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"requirements-cell"},[(_vm.requirements.length == 0)?_c('span',[_c('i',[_vm._v("no requirements defined")])]):_vm._l((_vm.requirements),function(requirement,index){return _c('div',{key:index},[_c('requirement',{attrs:{"requirement":requirement}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }